"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultValue = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
var _constants = _interopRequireDefault(require("../../../constants"));
var _dateTime = _interopRequireDefault(require("../../../dateTime"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var getDefaultValue = function getDefaultValue(value, locale) {
  if (_lodash.default.isNull(value)) return undefined;
  if (value) {
    return (0, _momentTimezone.default)(value, _constants.default.DateTimeFormat.shortDate, true).locale(locale).format(_constants.default.DateTimeFormat.shortDate);
  }
  return value;
};
exports.getDefaultValue = getDefaultValue;
var CustomQuestionDate = function CustomQuestionDate(props) {
  var question = props.question;
  var isDesignMode = question.isDesignMode,
    isReadOnly = question.isReadOnly,
    locale = question.locale;
  var inputProps = {
    placeholder: isDesignMode ? '' : 'Select a date',
    className: isDesignMode ? 'sd-text sd-input' : 'sd-text'
  };
  var dateTimeRef = _react.default.useRef(null);
  (0, _react.useEffect)(function () {
    if (question.value) {
      var newValue = getDefaultValue(question.value, locale);
      if (newValue !== question.value) {
        question.value = newValue;
      }
    }
  });
  var onUpdateValue = function onUpdateValue(newValue) {
    question.value = newValue;
  };
  var onFocus = function onFocus() {
    // register scrollIntoView to run before the next repaint
    window.requestAnimationFrame(function () {
      if (!dateTimeRef || !dateTimeRef.current || !dateTimeRef.current.container || !dateTimeRef.current.container.current) {
        return;
      }
      var datePicker = dateTimeRef.current.container.current.querySelector('.rdtOpen > .rdtPicker');
      if (datePicker) {
        datePicker.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    });
  };
  var checkInvalidDate = function checkInvalidDate(renderedDate, maxDate, minDate) {
    var max = (0, _momentTimezone.default)(maxDate, _constants.default.DateTimeFormat.shortDate, true);
    var min = (0, _momentTimezone.default)(minDate, _constants.default.DateTimeFormat.shortDate, true);
    if (max.isValid() && min.isValid()) {
      return renderedDate.isSameOrBefore(max) && renderedDate.isSameOrAfter(min);
    }
    if (max.isValid() || min.isValid()) {
      if (max.isValid()) {
        return renderedDate.isSameOrBefore(max);
      }
      return renderedDate.isSameOrAfter(min);
    }
    return true;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "datetime-picker-field ".concat(question.errors.length ? 'error-field' : '')
  }, /*#__PURE__*/_react.default.createElement(_dateTime.default, {
    ref: dateTimeRef,
    name: question.name,
    viewMode: "days",
    dateFormat: _constants.default.DateTimeFormat.shortDate,
    timeFormat: false,
    className: "date-custom",
    defaultValue: getDefaultValue(question.value, locale),
    isValidDate: function isValidDate(renderedDate) {
      return checkInvalidDate(renderedDate, question.max, question.min);
    },
    onChange: function onChange(e) {
      if (_momentTimezone.default.isMoment(e)) {
        var dob = (0, _momentTimezone.default)(e).format(_constants.default.DateTimeFormat.shortDate);
        onUpdateValue(dob);
      } else {
        onUpdateValue(e);
      }
    },
    onFocus: onFocus,
    disabled: isDesignMode || isReadOnly,
    inputProps: inputProps,
    clearable: true,
    locale: locale
  }));
};
CustomQuestionDate.propTypes = {
  question: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    isDesignMode: _propTypes.default.bool.isRequired,
    errors: _propTypes.default.instanceOf(Array).isRequired,
    value: _propTypes.default.shape({}).isRequired,
    title: _propTypes.default.string.isRequired,
    requiredErrorText: _propTypes.default.string.isRequired,
    defaultValue: _propTypes.default.string.isRequired,
    isRequired: _propTypes.default.bool.isRequired,
    isReadOnly: _propTypes.default.bool.isRequired,
    min: _propTypes.default.string,
    max: _propTypes.default.string,
    locale: _propTypes.default.string
  }).isRequired
};
CustomQuestionDate.defaultProps = {};
var _default = CustomQuestionDate;
exports.default = _default;